import React, { useState, useEffect } from 'react';
import './EmployeeTermination.css';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router-dom";
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { getDistrict, getDistrictByZoneId, getStates } from '../../../services/monthlyAttendanceService';
import { getEmployyesforTransfor } from '../../../services/transport';
import { format } from 'date-fns';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { getDesignationsForEmployees } from '../../../services/shiftsService';
import { terminationRequest } from '../../../services/resignationService';

const EmployeeTermination = () => {
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [employeeName, setEmployeeName] = useState(null);
    const [designation, setDesignation] = useState("");
    const [presentState, setPresentState] = useState("");
    const [presentDistrict, setPresentDistrict] = useState("");
    const [presentLocation, setPresentLocation] = useState("");
    const zoneId = localStorage.getItem("zoneId");
    const requestedBy = localStorage.getItem("employeeId");
    const [isFocused, setIsFocused] = useState({
        employeeName: false,
        reportingTo: false,
        fromDate: false,
        terminationDate: false,
    });
    const [reason, setReason] = useState('')

    const [reportingTo, setReportingTo] = useState(null);
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [draftId, setDraftId] = useState("");
    const [errors, setErrors] = useState({});
    const [postingDesignation, setPostingDesignation] = useState(null);
    const [toLocation, setToLocation] = useState(null);
    const [designationOptions, setDesignationOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [terminationDate, setTerminationDate] = useState(null);
    const [fromDate, setFromDate] = useState(null);

    const [desginationsForEmployees, setDesignationForEmployees] = useState([]);
    const [seletedDesignation, setSelectedDesignation] = useState('');


    console.log(' zone id', zoneId);
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const response = await getEmployyesforTransfor(state, district, seletedDesignation);
                const data = response.data;

                if (Array.isArray(data)) {
                    setEmployees(
                        data.map((item) => ({
                            value: item.employeeUniqueId,               // or item.postingId if needed
                            label: `${item.fullName} - ${item.contactNumber}`,
                            designation: item.designation || "",
                            presentState: item.stateName || "",
                            presentDistrict: item.districtName || "",
                            // We'll compute presentLocation dynamically later
                            workLocations: item.workLocations || [],
                            godowns: item.godowns || [],
                            draftId: item.employeeUniqueId,                    // assuming draftId is employeeId
                            raw: item
                        }))
                    );
                }
            } catch (error) {
                console.error("Error fetching employees:", error);
                setErrors(prev => ({ ...prev, general: "Error fetching employees" }));
            }
        };

        if (district) {
            fetchEmployees();
        } else {
            setEmployees([]);
        }
    }, [district, state, seletedDesignation]); // Keep state if filtering by state too

    useEffect(() => {

        const fetchStates = async () => {
            try {
                const res = await getStates();
                setStateOptions(res.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName)
                })));
            } catch (err) {
                setErrors(prev => ({ ...prev, general: "Failed to load states" }));
            }
        };


        fetchStates();
    }, []);
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrictByZoneId(zoneId);

                    // Log to see what you're actually getting
                    console.log('API response:', data);
                    console.log('Response type:', typeof data);
                    console.log('Is array?', Array.isArray(data));

                    // Handle different response structures
                    let districts = [];
                    if (Array.isArray(data)) {
                        districts = data;
                    } else if (data && data.districts && Array.isArray(data.districts)) {
                        districts = data.districts;
                    } else if (data && data.data && Array.isArray(data.data)) {
                        districts = data.data;
                    } else {
                        console.warn('Unexpected API response structure:', data);
                        setDistrictOptions([]);
                        return;
                    }

                    setDistrictOptions(
                        districts.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                    setDistrictOptions([]); // Reset on error
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);





    useEffect(() => {
        const fetchDesignationForEmployyes = async () => {
            try {
                const response = await getDesignationsForEmployees();
                const options = response.map(item => ({
                    value: item.id,
                    label: item.designationName,
                    shortName: item.designationShortName,
                }));
                setDesignationForEmployees(options);
            }
            catch (error) {
                console.log("Get all Designations before fetching ");
            }
        };
        fetchDesignationForEmployyes();
    }, [])

    // useEffect(() => {
    //     const fetchDesignations = async () => {
    //         const selectedObj = desginationsForEmployees.find(
    //             (item) => item.value === seletedDesignation
    //         );

    //         if (selectedObj && selectedObj.shortName) {
    //             try {
    //                 const response = await axios.get(
    //                     `${process.env.REACT_APP_API_BASE_URL}/api/designations/dropdown/by-designation?shortName=${selectedObj.shortName}`
    //                 );
    //                 const options = response.data.map(item => ({
    //                     value: item.id,
    //                     label: item.designationName,
    //                     // Use the specific shortName for THIS item (e.g., CMR_DEO)
    //                     shortName: item.designationShortName
    //                 }));
    //                 setDesignationOptions(options);
    //             } catch (error) {
    //                 console.error('Error fetching designations:', error);
    //             }
    //         } else {
    //             setDesignationOptions([]);
    //         }
    //     };
    //     fetchDesignations();
    // }, [seletedDesignation, desginationsForEmployees]);


    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;

        switch (field) {
            case "employeeName":
                setEmployeeName(selectedOption ? selectedOption.value : null);
                if (selectedOption) {
                    setDesignation(selectedOption.designation || "");
                    setDraftId(selectedOption.draftId || "");
                    setPresentState(selectedOption.presentState || "");
                    setPresentDistrict(selectedOption.presentDistrict || "");

                    // New logic for presentLocation
                    const locations = selectedOption.workLocations;
                    const godowns = selectedOption.godowns;

                    let locationDisplay = "";
                    if (Array.isArray(locations) && locations.length > 0) {
                        locationDisplay = locations.join(", ");
                    } else if (Array.isArray(godowns) && godowns.length > 0) {
                        locationDisplay = godowns.join(", ");
                    } else {
                        locationDisplay = "N/A";
                    }

                    setPresentLocation(locationDisplay);
                } else {
                    setDesignation("");
                    setDraftId("");
                    setPresentState("");
                    setPresentDistrict("");
                    setPresentLocation("");
                }
                break;

            case 'designationForEmp':
                setSelectedDesignation(value);
                setPresentLocation('');
                setEmployeeName('');
                setPostingDesignation('');
                break;

            case 'state':
                setState(value);
                setDistrict(null);
                break;
            case 'district':
                setDistrict(value);
                break;

            case "toLocation":
                setToLocation(selectedOption || []);
                break;
            default:
                break;


        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!employeeName) newErrors.employeeName = "Employee Name is required";
        if (!district) newErrors.district = "District is required";
        if (!designation) newErrors.designation = "Desigantion is requires"
        if (!terminationDate) newErrors.terminationDate = " Termination date is required"
        if (!reason) newErrors.reason = " Reason is requires"
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleClear = () => {
        setEmployeeName(null);
        setDesignation("");
        //setDesignationForEmployees([]);
        setSelectedDesignation(null);
        setFromDate(null);
        setTerminationDate('');
        setReason('');
        setToLocation(null);
        setErrors({});
        setDistrict("");
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        const payload = {
            employeeUniqueId: draftId,
            terminationDate: format(terminationDate, 'yyyy-MM-dd'),
            reason: reason,
            requestedBy,
            auditlog: getAuditLog(), // Uncomment if needed
        };

        console.log("Payload being sent:", payload); // Debug log
        console.log("API URL:", `${process.env.REACT_APP_API_BASE_URL}/api/termination/request`); // Debug log

        try {
            const response = await terminationRequest(payload);
            console.log("API Response:", response); // Debug log
            alert("Employee termination saved successfully!");
            handleClear();
        } catch (err) {
            console.error("Full error object:", err); // Debug log
            console.error("Error response:", err.response); // Debug log
            setErrors(prev => ({
                ...prev,
                general: err.response?.data?.message || err.message || "Error saving employee termination"
            }));
        }
    };


    return (
        <div className="employee-termination-maincontainer">
            <div className="employee-termination-box">
                <h2 className="employee-termination-heading">Employee Termination</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}

                <div className="employee-termination-structure-heading">

                    <div className="employee-termination-maincontainer-1">
                        <div className="employee-termination-container-part">
                            <div className={`employee-termination-floating-label-container-2 ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="employee-termination-container-part">
                            <div className={`employee-termination-floating-label-container-2 ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>

                    {/* Employee Dropdown */}
                    <div className="employee-termination-maincontainer-1">


                        <div className="employee-termination-container-part">
                            <div className={`employee-termination-floating-label-container-2 ${isFocused.seletedDesignation || seletedDesignation ? "float-label" : ""}`}>
                                <Select
                                    name='designation'
                                    options={desginationsForEmployees}
                                    // This ensures that if the ID is null/empty, the Select component resets to empty
                                    value={desginationsForEmployees.find(opt => opt.value === seletedDesignation) || null}
                                    onChange={(option) => handleInputChange(option, "designationForEmp")}
                                    isClearable


                                />
                                <label><span className="required">*</span>Designation</label>
                                {errors.designation && <div className="error-message">{errors.designation}</div>}
                            </div>
                        </div>


                        <div className="employee-termination-container-part">
                            <div className={`employee-termination-floating-label-container-2 ${isFocused.employeeName || employeeName ? "float-label" : ""}`}>
                                <Select
                                    name="employeeName"
                                    options={employees}
                                    value={employees.find(opt => opt.value === employeeName) || null}
                                    onChange={(option) => handleInputChange(option, "employeeName")}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, employeeName: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, employeeName: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Employee Name</label>
                                {errors.employeeName && <div className="error-message">{errors.employeeName}</div>}
                            </div>
                        </div>

                    </div>

                    {/* Read-only employee details */}


                    <div className="employee-termination-maincontainer-1">

                        <div className="employee-termination-container-part">
                            <div className={`employee-termination-floating-label-container-2 ${isFocused.terminationDate || terminationDate ? "float-label" : ""}`}>

                                <DatePicker
                                    selected={terminationDate}
                                    onChange={(date) => setTerminationDate(date)}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="Select a date"
                                    className="did-floating-input"
                                    minDate={new Date()}
                                />
                                <label><span className="required">*</span>Termination Date</label>
                                {errors.terminationDate && <div className="error-message">{errors.terminationDate}</div>}
                            </div>
                        </div>
                        <div className="employee-termination-container-part">
                            <div className="employee-termination-floating-label-container-2">
                                <input type="text"
                                    value={reason}
                                    onChange={(e) => { setReason(e.target.value) }}
                                    placeholder=" " />
                                <label><span className="required">*</span>Reason</label>
                                {errors.reason && <div className="error-message">{errors.reason}</div>}
                            </div>
                        </div>
                    </div>



                    {/* Buttons */}
                    <div className="employee-termination-btn-div">
                        {/* <button type="button" className="employee-termination-cancel" onClick={handleClear}>
                            Cancel
                        </button> */}
                        <button type="button" className="employee-termination-clear" onClick={handleClear}>
                            Clear
                        </button>
                        <button type="button" className="employee-termination-btn" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeTermination;
